import { http, HttpResponse } from 'msw'

import { allProducts } from 'app/mocks/data/catalogue/products'

import { searchParametersProductApi } from 'app/utils/catalogue/products/list'
import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { ProductsRequest } from 'app/types/catalogue/product'

export const getAllProducts = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersProductApi.MANAGERS,
        )

        const categoryIdsFilter = searchParams.get(
            searchParametersProductApi.CATEGORIES,
        )

        const supplierIdsFilter = searchParams.get(
            searchParametersProductApi.SUPPLIERS,
        )

        const nameFilter = searchParams.get(searchParametersProductApi.NAME)
        const statusFilter = searchParams.get(searchParametersProductApi.STATUS)

        let allProductsFiltered = allProducts

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allProductsFiltered = allProductsFiltered.filter((product) =>
                managerIdsSplit.includes(product.client.id),
            )
        }

        // Category filter
        if (categoryIdsFilter) {
            const categoryIdsSplit = queryIntoArrayNumber(categoryIdsFilter)

            allProductsFiltered = allProductsFiltered.filter((product) =>
                categoryIdsSplit.includes(product.category.id),
            )
        }

        // Supplier filter
        if (supplierIdsFilter) {
            const supplierIdsSplit = queryIntoArrayNumber(supplierIdsFilter)

            allProductsFiltered = allProductsFiltered.filter((product) =>
                supplierIdsSplit.includes(product.supplier.id),
            )
        }

        // Name filter
        if (nameFilter) {
            allProductsFiltered = allProductsFiltered.filter((product) =>
                product.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Status filter
        if (statusFilter) {
            allProductsFiltered = allProductsFiltered.filter(
                (product) => product.disabled.toString() === statusFilter,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allProductsFiltered.length > limit
                ? offset + limit
                : allProductsFiltered.length

        const results = allProductsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allProductsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ProductsRequest>({
            next,
            results,
        })
    },
)
